import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageType } from './analytics/newrelic/enums/PageType';
import { LangGuard } from './shared/guards/lang/lang.guard';
import { CoreResolver } from './shared/resolvers/core.resolver';
import { PlanResolver } from './shared/resolvers/plan.resolver';
import { DetailPageComponent } from './detail-page/detail-page.component';
import { DetailsPageResolver } from './shared/resolvers/details-page.resolver';
import { PlayerResolver } from './shared/resolvers/player.resolver';
import { PlayerGuard } from './shared/guards/player.guard';
import { SessionTimeoutComponent } from './shared/shared-components/session-timeout/session-timeout.component';

const routes: Routes = [
  {
    path: 'session-timeout',
    component: SessionTimeoutComponent,
  },
  {
    path: 'new-preferred-language-selection',
    loadChildren: () =>
      import('./new-preferred-language-selection/new-preferred-language-selection.module').then(
        (m) => m.NewPreferredLanguageSelectionModule
      ),
    data: {
      pageID: PageType.Language,
    },
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
    data: {
      pageID: PageType.Onboarding,
    },
  },
  {
    path: 'link-tv',
    loadChildren: () =>
      import('./link-tv/link-tv.module').then((m) => m.LinkTvModule),
    data: {
      pageID: PageType.LinkDevice,
    },
  },
  {
    path: 'tv-payments',
    data: {
      pageID: PageType.Payment,
    },
    loadChildren: () =>
      import('./tv-payments/tv-payments.module').then(
        (m) => m.TvPaymentsComponentModule
      ),
  },
  {
    path: 'tv-payments-abroad',
    data: {
      pageID: PageType.Payment,
    },
    loadChildren: () =>
      import('./tv-payments-abroad/tv-payments-abroad.module').then(
        (m) => m.TvPaymentsAbroadModule
      ),
  },
  {
    path: 'send-payment-link',
    data: {
      pageID: PageType.Payment,
    },
    loadChildren: () =>
      import('./send-payment-link/send-payment-link.module').then(
        (m) => m.SendPaymentLinkModule
      ),
  },
  {
    path: 'rent-now',
    data: {
      pageID: PageType.Payment,
    },
    loadChildren: () =>
      import('./rent-now/rent-now.module').then((m) => m.RentNowModule),
  },
  {
    path: 'plans',
    loadChildren: () =>
      import('./plans/plans.module').then((m) => m.PlansModule),
    data: {
      fetchProfiles: true,
      fetchEntitlements: true,
      pageID: PageType.ViewPlans,
    },
    resolve: {
      plans: PlanResolver,
      core: CoreResolver,
    },
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((m) => m.SettingsModule),
    data: {
      pageID: PageType.Settings,
    },
  },
  {
    path: 'player/:type/:id',
    canActivate: [PlayerGuard],
    data: {
      fetchEntitlements: true,
      pageID: PageType.Player,
      fetchProfiles: false,
      fetchVodEntitlements: false,
      isDetailPageCards: true,
    },
    resolve: {
      coreData: CoreResolver,
      playerData: PlayerResolver,
    },
    loadChildren: () =>
      import('./player/player.module').then((m) => m.PlayerModule),
  },
  {
    path: '',
    data: { preload: true, pageID: PageType.Browse },
    canActivate: [LangGuard],
    loadChildren: () =>
      import('./storefront/storefront.module').then((m) => m.StorefrontModule),
  },
  {
    path: ':contentType/:id',
    component: DetailPageComponent,
    canActivate: [LangGuard],
    data: {
      fetchEntitlements: true,
      pageID: PageType.Details,
      fetchProfiles: false,
      fetchVodEntitlements: false,
      isDetailPageCards: true,
    },
    resolve: {
      coreData: CoreResolver,
      detailData: DetailsPageResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [PlanResolver, CoreResolver, DetailsPageResolver, PlayerResolver],
})
export class AppRoutingModule {}
